import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import Button from './Button'

import './ConfirmationOverlay/index.scss'

export default function AlertOverlay({ message, subMessage, onDismiss }: any) {
  return (
    <div className="confirmation__overlay">
      <div className="confirmation__box">
        <p className="confirmation__message">{message}</p>
        {!!subMessage && <p className="confirmation__sub_message">{subMessage}</p>}

        <div className="confirmation__actionblock">
          <Button color="primary" onClick={onDismiss}>
            <FormattedMessage id="Close" defaultMessage="Close" />
          </Button>
        </div>
      </div>
    </div>
  )
}

AlertOverlay.propTypes = {
  onDismiss: PropTypes.func.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  subMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}

AlertOverlay.defaultProps = {
  message: <FormattedMessage id="Attention" defaultMessage="Attention" />,
  subMessage: ''
}
